import { AxiosError } from 'axios';
import { useMutation } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { BaseError } from '@utils/types/shared/base.ts';

export interface NewRegistrationData {
  product: string | null;
}

interface RegistrationResponse {
  count: number;
  total_results: number;
  result: {
    mollie_checkout_url: string;
  };
}

export const usePaymentRegistration = () => {
  const registerWithPaymentUser = async (
    userData: NewRegistrationData
  ): Promise<RegistrationResponse> => {
    const response = await Axios.post<RegistrationResponse>(
      POST_URL().registerWithPayment,
      userData
    );
    return response.data;
  };

  return useMutation<
    RegistrationResponse,
    AxiosError<BaseError>,
    NewRegistrationData
  >(registerWithPaymentUser);
};
